import React, { Component } from "react";
import { Row, Col, Select, notification } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import {
  ModalItem,
  Form,
  FormItem,
  InputItem,
  SelectItem,
  ButtonItem,
} from "../../../../Components/Items";

const { Option } = Select;

class ModalCampoLead extends Component {
  formRef = React.createRef();

  state = {
    guardando: false,
    tipoSeleccionado: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      const { campoAEditar } = this.props;
      if (campoAEditar) {
        this.setState({ tipoSeleccionado: campoAEditar.tipo }, () => {
          this.formRef.current?.setFieldsValue(campoAEditar);
        });
      } else {
        this.setState({ tipoSeleccionado: null }, () => {
          this.formRef.current?.resetFields();
        });
      }
    }
  }

  onValuesChange = (changedValues) => {
    if ("tipo" in changedValues) {
      this.setState({ tipoSeleccionado: changedValues.tipo });
    }
  };

  onFinish = (values) => {
    const { campoAEditar, empresaId } = this.props;

    this.setState({ guardando: true });
    axios
      .post(
        "camposLead/guardarCampoLead",
        {
          ...values,
          _id: campoAEditar?._id,
          empresaId,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: res.data.message });
          this.props.onExito();
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => {
        notification.error({ message: "Error al guardar el campo." });
      })
      .finally(() => this.setState({ guardando: false }));
  };

  render() {
    const { visible, onCancel, campoAEditar } = this.props;
    const { guardando, tipoSeleccionado } = this.state;

    return (
      <ModalItem
        title={campoAEditar ? "Editar Campo" : "Nuevo Campo Personalizado"}
        visible={visible}
        onCancel={onCancel}
        width={600}
        spinning={false}
      >
        <Form
          ref={this.formRef}
          name="form_modal_campo_lead"
          layout="vertical"
          onFinish={this.onFinish}
          onValuesChange={this.onValuesChange}
          bottom={
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <ButtonItem
                rojo
                onClick={onCancel}
                style={{ marginRight: 8 }}
                disabled={guardando}
              >
                Cancelar
              </ButtonItem>
              <ButtonItem azul htmlType="submit" loading={guardando}>
                Guardar
              </ButtonItem>
            </div>
          }
        >
          <Row gutter={16}>
            <Col span={12}>
              <FormItem
                name="nombre"
                label="Nombre del Campo"
                required
                margin
                wrapperCol={12}
                labelCol={12}
              >
                <InputItem placeholder="Ej: Tamaño de empresa" />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                name="tipo"
                label="Tipo de Dato"
                required
                margin
                wrapperCol={12}
                labelCol={12}
              >
                <SelectItem placeholder="Selecciona un tipo">
                  <Option value="text">Texto Libre</Option>
                  <Option value="number">Número / Moneda</Option>
                  <Option value="date">Fecha</Option>
                  <Option value="boolean">Verdadero / Falso</Option>
                  <Option value="select">Lista Desplegable</Option>
                </SelectItem>
              </FormItem>
            </Col>
          </Row>

          {tipoSeleccionado === "select" && (
            <>
              <p style={{ color: "#5e6c84", fontSize: 13, marginBottom: 15 }}>
                <b>Opciones:</b> define los valores que el vendedor podrá
                elegir al llenar este campo.
              </p>
              <Form.List name="opciones">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Row
                        gutter={12}
                        key={key}
                        style={{
                          marginBottom: 12,
                          display: "flex",
                          alignItems: "flex-start",
                        }}
                      >
                        <Col span={20}>
                          <FormItem
                            {...restField}
                            name={name}
                            margin={false}
                            required
                            style={{ marginBottom: 0 }}
                          >
                            <InputItem placeholder="Ej: Chica" />
                          </FormItem>
                        </Col>
                        <Col
                          span={4}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            paddingTop: 4,
                          }}
                        >
                          <ButtonItem
                            rojo
                            icon={<DeleteOutlined />}
                            onClick={() => remove(name)}
                            style={{ padding: "0 8px" }}
                            tooltip="Eliminar opción"
                          />
                        </Col>
                      </Row>
                    ))}
                    <ButtonItem
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                      style={{ marginTop: 10 }}
                    >
                      Añadir Opción
                    </ButtonItem>
                  </>
                )}
              </Form.List>
            </>
          )}
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
  };
};

export default connect(mapStateToProps)(ModalCampoLead);
